import React from 'react';
import { Link } from 'react-router-dom';
import { useDarkClasses } from '../../hooks/useDarkClasses';
import { useRoleTheme } from '../../hooks/useRoleTheme';
import { usePlatform } from '../../context/PlatformContext';
import { handleImgError } from '../../utils/imageUtils';
import { TroveArticle } from '../../data/homePageData';
interface TroveArticleCardProps {
  article: TroveArticle;
}
export const TroveArticleCard: React.FC<TroveArticleCardProps> = ({
  article
}) => {
  const dk = useDarkClasses();
  const rt = useRoleTheme();
  const {
    isAfterTide
  } = usePlatform();
  return <div className={`rounded-xl shadow-sm overflow-hidden flex flex-col border hover:shadow-md transition-shadow ${dk.card}`} data-id="element-1892" data-mp="1iw7cnc4g4sr1">
      <div className="h-48 relative overflow-hidden" data-id="element-1893" data-mp="1ew588v7btl82">
        <img src={article.image} alt={article.title} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" onError={handleImgError} data-id="element-1894" data-mp="1sumu0ndo8nnc" />
        <div className="absolute top-3 left-3" data-id="element-1895" data-mp="2ouq5zh72840j">
          <span className={`text-xs font-bold px-2.5 py-1 rounded-full ${isAfterTide ? 'bg-[#e2b04a] text-[#1a1a2e]' : 'bg-indigo-500 text-white'}`} data-id="element-1896" data-mp="2ow1a5i4f3ds6">
            {article.category}
          </span>
        </div>
      </div>
      <div className="p-5 flex-1 flex flex-col" data-id="element-1897" data-mp="32uhh9a66z6au">
        <div className="flex items-center justify-between mb-2" data-id="element-1898" data-mp="32vat2pk0clzu">
          <span className={`text-xs ${dk.textMuted}`} data-id="element-1899" data-mp="37s16t68cb5i3">{article.date}</span>
        </div>
        <h3 className={`text-lg font-bold mb-2 line-clamp-2 ${dk.textPrimary}`} data-id="element-1900" data-mp="3crds3mjkc4ik">
          {article.title}
        </h3>
        <p className={`text-sm mb-4 line-clamp-2 flex-1 ${dk.textSecondary}`} data-id="element-1901" data-mp="3hk6wg9b4dau4">
          {article.excerpt}
        </p>
        <div className="flex items-center justify-between mt-auto pt-4 border-t border-gray-100 dark:border-gray-800" data-id="element-1902" data-mp="3mh5pspmyldr9">
          <span className={`text-xs font-medium ${dk.textPrimary}`} data-id="element-1903" data-mp="3qhpkznnz27ar">
            By {article.author}
          </span>
          <Link to={`/trove/article/${article.id}`} className={`text-xs font-bold ${rt.accentLink}`} data-id="element-1904" data-mp="1vg4cxgqt060t">
            Read →
          </Link>
        </div>
      </div>
    </div>;
};